import styled from "styled-components";
import { media } from "../../theme/theme";
import { PerksUL } from "../MarketingPricingBlock/MarketingPricingBlock.styles";
import { MarketingSpacing } from "../ReusableStyledComponents/MarketingSpacing";
import { Body, H4, MediumText } from "../Typography";

export const MarketingStepsWrapper = styled.div`
    max-width: 1300px;
    margin: 0 auto;
    ${MarketingSpacing}
`;

export const StepText = styled.div`
    text-align: left;

    ${media.tablet} {
        max-width: 486px;
    }

    ${Body} {
        color:  ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
    }

    ${H4} {
        color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue80 : null};
        
        ${media.tablet} {
            max-width: 384px;
        }
    }
`;

export const CTextIcon = styled(MediumText)`
    display: flex;
    align-items: center;
    color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};

    > * {
        &:first-child {
            margin-right: 13px;
        }
    }
`;

export const StepWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    align-items: center;

    ${media.tablet} {
        margin-bottom: 63px;
    }

    > div {
        width: 100%;

        ${media.tablet} {
            width: calc(50% - 15px); 
        }

        &:nth-child(1) {
            ${media.tablet} {
                max-width: 488px;
            }
        }

        &:nth-child(2) {
            ${media.tablet} {
                max-width: 488px;
            }
        }
    }
`;

export const StepSVG = styled.svg`
    width: 100%;
    height: auto;
    max-width: 488px;
    margin: 0 auto;
    display: block;
`;

export const StepPerkz = styled(PerksUL)`
    display: block;
    min-width: initial;

    > li {
        color:  ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};

        &:before {
            top: 16px;
        }
    }
`;